<template>
  <v-select
    :id="id"
    v-model="getValue"
    :outlined="outlined"
    :color="color"
    v-bind="$attrs"
    @blur="$emit('blur', $event)"
  />
</template>

<script>
import VuetifyOverwriteMixin from 'Arch/components/global-components/VuetifyOverwriteMixin';

export default {
  name: 'InputSelect',
  mixins: [VuetifyOverwriteMixin],
};

</script>
